import React from "react";
import {Avatar, Flex, Space} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {useViewerStore} from "../../../../../../store/store";
import {useCurrentUser} from "../../../../../../contexts/UserContext";

const UserInfoSection : React.FC = () => {

    const {user} = useCurrentUser();
    const {isProfilePhotoAvailable, userProfilePhoto } =  useViewerStore();

    return(
        <Space direction='horizontal'>
            {
                isProfilePhotoAvailable ?
                    <Avatar
                        size={50}
                        src={userProfilePhoto}
                    />
                    :
                    <Avatar
                        size={50}
                        icon={<UserOutlined/>}
                    />
            }
            <Flex
                vertical
                justify={'center'}
                align={'left'}
            >
                <h4 className='user__name'>{user?.user_name}</h4>
                <span className='user__email'>{user?.email}</span>

            </Flex>
        </Space>
    )
}

export default UserInfoSection;